import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import clsx from 'clsx';
import useResponsive from 'utils/responsive';
import CartIcon from 'utils/icon/icon-cart.svg';
import PlusIcon from 'utils/icon/icon-plus.svg';
import { decodeId } from 'utils/helpers';
import Media from 'utils/media';

const Hero = ({ props }) => {
  const { isMobile } = useResponsive();
  const { product } = props;

  const keepOnRightLarge = props.textAlignDesktop.includes('right')
    ? props.textAlignDesktop.includes('bottom') &&
      props.textPosition === 'include'
      ? 'md:!bottom-56'
      : 'md:!bottom-16'
    : 'lg:!left-auto lg:!right-16 lg:!bottom-56';
  const verticalPositionBottom = product?.handle
    ? `!left-16 !bottom-16 !top-auto ${keepOnRightLarge}`
    : '!left-auto !right-16 !bottom-16 !top-auto';

  const [controlClass, setControlClass] = useState(false);

  useEffect(() => {
    const setControlClassVal = () => {
      setControlClass(
        document.querySelector('[data-section="header"] > .absolute')// eslint-disable-next-line max-len
          ? `ml:!w-32 ml:!h-32 lc:!w-36 lc:!h-36 lc:hover:border lc:hover:border-black ${verticalPositionBottom} !opacity-100`
          : 'ml:!w-32 ml:!h-32 lc:!w-36 lc:!h-36 lc:hover:border lc:hover:border-black !top-16 !left-auto !right-16 !opacity-100',
      );
    };
    setControlClassVal();
    document.addEventListener('headerDomReady', setControlClassVal);
    return () => {
      document.removeEventListener('headerDomReady', setControlClassVal);
    };
  }, []);

  const setupQuickView = () => {
    document.dispatchEvent(
      new CustomEvent(
        product.productType === 'Outfit'
          ? 'look-overlay:open'
          : 'quick-view:open',
        {
          detail:
            product.productType === 'Outfit'
              ? {
                  id: decodeId(product.id, 'Product'),
                }
              : {
                  handle: product.handle,
                },
        },
      ),
    );
  };

  const handleMediaClick = () => {
    if (props?.mediaLink) {
      window.location.href = props.mediaLink;
    }
  };

  return (
    <div className="flex flex-col">
      <div
        className={clsx(
          'relative flex overflow-hidden md:min-h-0 md:h-[700px]',
          {
            'md:justify-start md:items-start md:text-left':
              props.textAlignDesktop === 'top_left',
            'md:justify-end md:items-start md:text-left':
              props.textAlignDesktop === 'top_right',
            'justify-start items-start text-left':
              props.textAlignMobile === 'top_left',
            'justify-end items-start text-left':
              props.textAlignMobile === 'top_right',
            'md:justify-center md:items-center md:text-center':
              props.textAlignDesktop === 'center',
            'md:justify-start md:items-end md:text-left':
              props.textAlignDesktop === 'bottom_left',
            'md:justify-end md:items-end md:text-left':
              props.textAlignDesktop === 'bottom_right',
            'justify-center items-center text-center':
              props.textAlignMobile === 'center',
            'justify-start items-end text-left':
              props.textAlignMobile === 'bottom_left',
            'justify-end items-end text-left':
              props.textAlignMobile === 'bottom_right',
            'min-h-100vw': props.ratioMobile === 'square',
            'h-auto aspect-[375/500] ml:aspect-[375/586]': props.ratioMobile === '3:4',
            'h-[375px]': props.textPosition === 'outside',
            'cursor-pointer': props?.mediaLink,
          },
        )}
      >
        {isMobile &&
          (props.displayMobile === 'image' ? (
            <Media
              mediaContentType="IMAGE"
              previewImage={props.imageMobile}
              srcWidths={{ sm: 375, md: 750 }}
              lazyLoad={props.lazyLoad}
              className="w-full h-full object-cover absolute inset-0 z-10"
              onClick={() => (props?.mediaLink ? handleMediaClick() : null)}
            />
          ) : (
            <Media
              {...props.videoMobile}
              className="absolute inset-0 object-cover h-full w-full"
              controlClass={controlClass}
              parentClass="z-10"
              lazyLoad={props.lazyLoad}
              onClick={() => (props?.mediaLink ? handleMediaClick() : null)}
            />
          ))}

        {!isMobile &&
          (props.displayDesktop === 'image' ? (
            <Media
              mediaContentType="IMAGE"
              previewImage={props.imageDesktop}
              srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
              className="w-full h-full object-cover absolute inset-0 z-10"
              lazyLoad={props.lazyLoad}
              onClick={() => (props?.mediaLink ? handleMediaClick() : null)}
            />
          ) : (
            <Media
              {...props.videoDesktop}
              className="absolute inset-0 object-cover h-full w-full"
              controlClass={controlClass}
              lazyLoad={props.lazyLoad}
              parentClass="z-10"
              onClick={() => (props?.mediaLink ? handleMediaClick() : null)}
            />
          ))}
        {props.textPosition === 'include' && <HeroText props={props} />}

        {product?.handle && (
          <button
            className={clsx(
              'bottom-16 right-16 absolute items-center justify-center bg-white lc:py-8 lc:cta-text-icon ml:w-32 ml:h-32 flex lc:gap-8 lc:rounded-full lc:border border-grey-300 z-20',
              {
                'md:left-16 md:right-auto':
                  props.textAlignDesktop === 'bottom_right' &&
                  props.textPosition === 'include',
                'lc:px-16': product.productType === 'Outfit',
                'lc:!p-8': product.productType !== 'Outfit',
              },
            )}
            onClick={(e) => {
              e.preventDefault();
              setupQuickView();
            }}
          >
            <PlusIcon className="w-16 h-auto lc:hidden" />
            <CartIcon
              className={clsx('h-auto ml:hidden', {
                'w-14': product.productType === 'Outfit',
                'w-18': product.productType !== 'Outfit',
              })}
            />
            <span
              className={clsx('body-3 ml:hidden', {
                'lc:hidden': product.productType !== 'Outfit',
              })}
              onClick={(e) => {
                e.preventDefault();
                setupQuickView();
              }}
            >
              {window.TMW.Strings.product.shopTheLook}
            </span>
          </button>
        )}
      </div>
      {props.textPosition !== 'include' && <HeroText props={props} />}
    </div>
  );
};

const HeroText = ({ props }) => {
  const [headerIsTransparent, setHeaderIsTransparent] = useState(false);

  useEffect(() => {
    const setHeaderIsTransparentVal = () => {
      setHeaderIsTransparent(
        document.querySelector('[data-section="header"] > .absolute'),
      );
    };
    setHeaderIsTransparentVal();
    document.addEventListener('headerDomReady', setHeaderIsTransparentVal);
    return () => {
      document.removeEventListener('headerDomReady', setHeaderIsTransparentVal);
    };
  }, []);

  if (!props.displayText) return '';
  return (
    <div
      className={clsx('z-10 px-24 md:px-56', {
        'py-[77.5px] md:py-56':
          props.ctaStyle === 'cta-primary' && props.textPosition === 'include',
        '!mb-[77.5px] !pb-0 !pt-[77.5px] lg:!mb-0 lg:!py-56 !mt-[77.5px] lg:!mt-56':
          headerIsTransparent && props.textPosition === 'include',
        'lc:md:my-40 ml:md:my-40':
          props.ctaStyle === 'cta-primary' &&
          props.textPosition === 'include' &&
          props.textAlignDesktop === 'bottom_left',
        'lc:md:my-46 ml:md:my-46':
          props.ctaStyle === 'cta-primary' &&
          props.textPosition === 'include' &&
          props.textAlignDesktop === 'bottom_right',
        'my-80':
          props.ctaStyle !== 'cta-primary' && props.textPosition === 'include',
        'mt-24 mb-40 md:my-32': props.textPosition !== 'include',
      })}
    >
      <div
        className={clsx(
          'flex flex-col z-20 md:w-half md:min-w-550 justify-center',
          {
            'md:text-white': props.themeDesktop === 'light',
            'md:text-default': props.themeDesktop === 'dark',
            'text-white': props.themeMobile === 'light',
            'text-default': props.themeMobile === 'dark',

            'md:justify-center md:items-center md:text-center md:mx-auto':
              props.textAlignDesktop === 'center',
            'justify-center items-center text-center mx-auto':
              props.textAlignMobile === 'center' &&
              props.textPosition === 'outside',
            'md:text-left md:items-start md:ml-0':
              (props.textAlignDesktop === 'top_left' ||
                props.textAlignDesktop === 'bottom_left') &&
              props.textPosition === 'outside',
            'text-left ml-0':
              (props.textAlignMobile === 'top_left' ||
                props.textAlignMobile === 'bottom_left') &&
              props.textPosition === 'outside',
            'md:text-left md:items-start md:ml-auto md:mr-0':
              props.textAlignDesktop === 'top_right' ||
              props.textAlignDesktop === 'bottom_right',
            'text-left ml-auto':
              (props.textAlignMobile === 'top_right' ||
                props.textAlignMobile === 'bottom_right') &&
              props.textPosition === 'outside',
          },
        )}
      >
        {props.eyebrow && <span className="mb-4 eyebrow">{props.eyebrow}</span>}
        {props.title && <div className="display-1 mb-16">{props.title}</div>}
        {props.description && (
          <div
            className={clsx('body-2 mb-24', {
              'lc:mb-16 ml:mb-16': props.textPosition !== 'include',
            })}
          >
            {props.description}
          </div>
        )}
        <div
          className={clsx('flex', {
            'flex-col gap-16': props.ctaStyle !== 'cta-primary',
            'flex-row flex-wrap gap-24': props.ctaStyle === 'cta-primary',
            'md:justify-center md:items-center':
              props.textAlignDesktop === 'center' &&
              props.textPosition === 'include',
            'md:justify-start md:items-start':
              props.textAlignDesktop !== 'center' &&
              props.textPosition === 'include',
            'justify-center items-center': props.textAlignMobile === 'center',
          })}
        >
          {props.ctaBlocks &&
            props.ctaBlocks.map((cta, index) => (
              <a
                href={cta.url}
                className={clsx({
                  'cta-primary': props.ctaStyle === 'cta-primary',
                  'button w-full': props.ctaStyle !== 'cta-primary',
                  'md:button--secondary-outline-white':
                    props.themeDesktop === 'light' &&
                    props.ctaStyle !== 'cta-primary',
                  'md:button--secondary-outline-black':
                    props.themeDesktop === 'dark' &&
                    props.ctaStyle !== 'cta-primary',
                  'button--secondary-outline-white':
                    props.themeMobile === 'light' &&
                    props.ctaStyle !== 'cta-primary',
                  'button--secondary-outline-black':
                    props.themeMobile === 'dark' &&
                    props.ctaStyle !== 'cta-primary',
                })}
                key={index}
              >
                {cta.text}
              </a>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
